import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AlphasActionType, AlphasStore } from './AlphasReducer.types';

// @ts-ignore
const initialState: AlphasStore = Immutable.fromJS({
  data: Immutable.Map(),
  isFetching: false,
  failure: false,
});

const AlphasReducer = handleActions(
  {
    DASHBOARD_ALPHAS_REQUEST: (state: AlphasStore) => state.set('isFetching', true),

    DASHBOARD_ALPHAS_RESPONSE_FAILURE: (state: AlphasStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_ALPHAS_RESPONSE: (state: AlphasStore, action: AlphasActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data)).set('failure', false),
  },
  initialState
);

export default AlphasReducer;
